/* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState } from 'react'

import './analytics.scss'

import { Link, useNavigate } from 'react-router-dom'
import { DatePicker } from "zaman"

import DeliveryIcon from '../../../assets/svg/PeykProfileIcon.svg'
import PeykProfileIcon from '../../../assets/svg/PeykProfile.svg'
import PeykMenuOrder from '../../../assets/svg/PeykMenuOrder-mini.svg'
import PeykMenuAnalyticActive from '../../../assets/svg/PeykMenuAnalytic-mini-active.svg'
import PeykMenuMessage from '../../../assets/svg/PeykMenuMessage-mini.svg'
import PeykMenuOrderDone from '../../../assets/svg/PeykMenuOrderDone-mini.svg'
import PeykHat from '../../../assets/svg/PeykHat-mini.svg'
import { post } from '../../../services/https'

export default function index() {
  const token = localStorage.getItem('token')

  const navigate = useNavigate()

  const [name, setName] = useState('...')

  const [successDelivery, setSuccessDelivery] = useState(0)
  const [salary, setSalary] = useState(0)
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  
  useEffect(() => {
    post('/api/front/users/verify', {
        token: localStorage.getItem('token')
      }).then(response => {
        // console.log(response)
        if (response.data.message === 'احراز هویت با موفقیت انجام شد') {

        } else {
          navigate('/peyk')
        }

    post('/api/front/peyks/info', {
        'phoneNumber': localStorage.getItem('phoneNumber')
      }).then(response => {
        setName(response.data.data.name)
      })

    }).catch(() => {
      navigate('/peyk')
    })
  }, [navigate, token])

  const analyzHandler = () => {
    console.log(fromDate, toDate)
  }

  return (
    <div id='peyk'>
      <header className='header'>
        <section className='header__name'>
          <div>
            <img src={DeliveryIcon} alt="DeliveryIcon" />
          </div>
          <div className='profileName'>
            <span className='profileName__self'>
              {name}
            </span>
            <span className='profileName__tag'>
              سفیر کانولی
            </span>
          </div>
        </section>
        <section className='header__profile'>
          <Link to='/peyk/profile'>
            <img src={PeykProfileIcon} alt="PeykProfileIcon" />
          </Link>
        </section>
      </header>
      <main className='body analytic__page'>
        <div className="body__title">
          حسابداری
        </div>
        <div className="form">
          <div className="form__item--twice">
            <div>
              <label htmlFor="">از تاریخ :</label>
              <DatePicker onChange={(e) => setFromDate(e.value)} />
            </div>
            <div>
              <label htmlFor="">تا تاریخ :</label>
              <DatePicker onChange={(e) => setToDate(e.value)} />
            </div>
          </div>
          <button onClick={analyzHandler}>محاسبه</button>
          <div className="form__analytic">
              تعداد سفر ها : {successDelivery} سفر <span style={{ color: '#11811C' }}>موفق</span> ، انجام شده
          </div>
          <div className="form__analytic form__analytic--two">
              درآمد : {salary} تومان
          </div>
        </div>
      </main>
      <nav className='navbar'>
        <Link to='/peyk/current' className='navbar__item'>
          <span>
            <img src={PeykMenuOrder} alt="PeykMenuOrderActive" />
          </span>
          <span>
            سفارشات
          </span>
        </Link>
        <Link to='/peyk/analytic' className='navbar__item'>
          <span>
            <img src={PeykMenuAnalyticActive} alt="PeykMenuAnalytic" />
          </span>
          <span className='navbar__item--active'>
            حسابداری
          </span>
        </Link>
        <Link to='/peyk/dashboard' className='navbar__item'>
          <span>
            <img src={PeykHat} alt="PeykHat" />
          </span>
          <span>
            سفیر
          </span>
        </Link>
        <Link to='/peyk/messages' className='navbar__item'>
          <span>
            <img src={PeykMenuMessage} alt="PeykMenuMessage" />
          </span>
          <span>
            پیام‌ها
          </span>
        </Link>
        <Link to='/peyk/orders' className='navbar__item'>
          <span>
            <img src={PeykMenuOrderDone} alt="" />
          </span>
          <span>
            انجام شده
          </span>
        </Link>
      </nav>
    </div>
  )
}
